import differenceInWeeks from 'date-fns-old/difference_in_weeks';
import differenceInDays from 'date-fns-old/difference_in_days';
import differenceInHours from 'date-fns-old/difference_in_hours';
import differenceInMinutes from 'date-fns-old/difference_in_minutes';

const handleExpirationTime = (date, useUtcTime) => {
  const now = new Date();
  const startTime = useUtcTime ? now.getTime() : now;
  const minsLeft = differenceInMinutes(date, startTime);
  const minsInHour = 60;
  const minsInDay = minsInHour * 24;
  const minsInWeek = minsInDay * 7;

  let expirationObj = {
    amount: minsLeft,
    units: 'mins',
  };

  if (minsLeft < 0) return 'Expired';

  if (minsLeft > minsInWeek) {
    expirationObj = {
      amount: differenceInWeeks(date, new Date()),
      units: 'weeks',
    };
  } else if (minsLeft > minsInDay) {
    expirationObj = {
      amount: differenceInDays(date, new Date()),
      units: 'days',
    };
  } else if (minsLeft > minsInHour) {
    expirationObj = {
      amount: differenceInHours(date, new Date()),
      units: 'hours',
    };
  }

  const expiration = `Expires in ${expirationObj.amount} ${expirationObj.units}`;
  return expiration;
};

export default handleExpirationTime;



// WEBPACK FOOTER //
// ./src/utils/handleExpirationTime.js